import styled from 'styled-components';
import {SwiperWrapperDefaultBox} from './swiper-wrapper.default.box';

export const SwiperWrapperCasino777Box = styled(SwiperWrapperDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        padding-top: 0.5rem;
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-top: 0;
    }
`;
